import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchFavorites } from "./store/features/favoritesSlice";

import Layout from "./components/Layout";
import SplashScreen from "./components/splash/SplashScreen";
import useTelegramAuth from "./hooks/useTelegramAuth";
import { trackShopOpen } from "./analytics";

// Pages
import HomePage from "./pages/HomePage";
import ProductPage from "./pages/ProductPage";
import CartPage from "./pages/CartPage";
import FavoritesPage from "./pages/FavoritesPage";
import ProfilePage from "./pages/ProfilePage";
import UserAddressPage from "./pages/UserAddressPage";
import OrdersPage from "./pages/OrdersPage";
import PromotionsPage from "./pages/PromotionsPage";
import MetaPageView from "./pages/MetaPageView";

// Скільки анімації заставки показати: девайси падають і стають, потім обидві "затяжки" (под і одноразка).
// Рахується за реально показаними кадрами, тож підвисання на старті не з'їдає анімацію.
const SPLASH_MIN_MS = 4300;
// Запасний ліміт за годинником — якщо анімація не змогла стартувати (напр. вкладка у фоні)
const SPLASH_MAX_WAIT_MS = SPLASH_MIN_MS + 3000;

function App() {
  const { isAuthReady } = useTelegramAuth();
  const dispatch = useDispatch();
  const [splashMinPassed, setSplashMinPassed] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setSplashMinPassed(true), SPLASH_MAX_WAIT_MS);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (isAuthReady) {
      dispatch(fetchFavorites());
      trackShopOpen();
    }
  }, [isAuthReady, dispatch]);

  return (
    <>
      <SplashScreen
        visible={!isAuthReady || !splashMinPassed}
        expectedMs={SPLASH_MIN_MS}
        onShowcaseDone={() => setSplashMinPassed(true)}
      />
      {isAuthReady && (
        <Router>
          <MetaPageView />

          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/product/:slug" element={<ProductPage />} />
              <Route path="/promotions" element={<PromotionsPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/favorites" element={<FavoritesPage />} />

              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/profile/addresses" element={<UserAddressPage />} />
              <Route path="/orders" element={<OrdersPage />} />
            </Route>
          </Routes>
        </Router>
      )}
    </>
  );
}

export default App;
